module.exports = __webpack_public_path__ + "img/slider.e5309cfb.jpg";